import get from 'lodash/get'
import isFinite from 'lodash/isFinite'
import reduce from 'lodash/reduce'

export const UNHANDLED_ERROR = 'Unhandled Error'
export const WRONG = 'Something went wrong'

export const getErrors = (error) => get(error, 'response.body.errors', [])

export const getFirstError = (error) => get(error, 'response.body.errors[0]', {})

export const getFirstPreformedError = (error) => {
  const err = getFirstError(error)

  return {
    title: err.title || WRONG,
    message: err.message || err.detail || UNHANDLED_ERROR,
    status: err.status || err.statusCode || 500,
  }
}

const processMessage = (message) => {
  const brooklynErrorSeparator = 'NR-LINKING'
  const processedMessage = message.split(brooklynErrorSeparator)[0].replace(/_/g, ' ')

  return processedMessage
}

export const getFirstErrorMessage = (error, messagePrefix = '') => {
  const err = getFirstError(error)
  const message = err.message || err.detail || UNHANDLED_ERROR
  const meta = reduce(err.meta, (acc, item) => `${acc} ${item}`, '')

  return `${messagePrefix}${processMessage(message)} ${meta}`
}

/**
 * Get the HTTP status from a superagent style error, or null when the request
 * never produced a response (aborted, offline, blocked by CORS)
 * @param {Error} error The request error
 * @returns {Number|null} The HTTP status or null
 */
export const getErrorStatus = (error) => {
  if (!error) {
    return null
  }
  if (isFinite(error.status)) {
    return error.status
  }
  if (isFinite(get(error, 'response.status'))) {
    return get(error, 'response.status')
  }
  return null
}

const RETRYABLE_STATUSES = [408, 429]

/**
 * True when a failed request is worth retrying. Requests that never reached a
 * server (status null or 0) are treated as transient, as are timeouts, rate
 * limits and server errors. Validation and auth failures are not retried.
 * @param {Error} error The request error
 * @returns {Boolean} True when the request should be retried
 */
export const isRetryableRequestError = (error) => {
  const status = getErrorStatus(error)
  if (status === null || status === 0) {
    return true
  }
  if (RETRYABLE_STATUSES.includes(status)) {
    return true
  }
  return status >= 500
}
